import { Modal } from 'antd';

export const showConfirm = ({
  onOk,
  title = 'Proceed?',
  okText = 'OK',
  cancelText = 'CANCEL',
  okType = 'customBlue',
  autoFocusButton = 'cancel',
  width = 600,
  ...props
}) => {
  Modal.confirm({
    title,
    okText,
    cancelText,
    onOk,
    okType,
    autoFocusButton,
    width,
    ...props,
  });
};

export const showDeleteConfirm = (props) =>
  showConfirm({
    title: 'Are you sure you want to delete?',
    okText: 'DELETE',
    ...props,
  });

export const showDuplicateConfirm = (props) =>
  showConfirm({
    title: 'Are you sure you want to duplicate these items?',
    okText: 'DUPLICATE',
    ...props,
  });

export const showUnpublishConfirm = (props) =>
  showConfirm({
    title: 'Are you sure you want to unpublish these items?',
    okText: 'UNPUBLISH',
    ...props,
  });

export const showCancelConfirm = (props) =>
  showConfirm({
    title: 'Are you sure?',
    okText: 'CONFIRM',
    ...props,
  });
